import { _ as _sfc_main } from "./VaSkeletonGroup.vue_vue_type_script_setup_true_lang.js";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper.js";
const VaSkeletonGroup_vue_vue_type_style_index_0_scoped_597bab9a_lang = "";
const _VaSkeletonGroup = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-597bab9a"]]);
export {
  _VaSkeletonGroup as _
};

import '../../../../VaSkeletonGroup.css';
//# sourceMappingURL=VaSkeletonGroup.js.map
